//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------

//  -- Constants ----------------------
import { ActionTypes } from 'store/constants';


//  ----------------------------------------------------------------------------
//  Reducers
//  ----------------------------------------------------------------------------

//  -- Example ------------------------
const init = {
    view: false
};


export const bingoModal = (state = init, action) => {
    switch (action.type) {
        case ActionTypes.bingo.invokeBingoModal:
            return ({ ...state, view: true});
        case ActionTypes.bingo.revokeBingoModal:
            return ({ ...state, view: false});
        default:
            return state;
    }
};


